<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <rcti-control></rcti-control>
      <rcti-view></rcti-view>
    </v-layout>
  </v-container>
</template>


<script>
import RctiControl from "@/components/rctis/rctiControl";
import RctiView from "@/components/rctis/rctiView";
import Store from "@/store/computed/storeHelpers";

export default {
  components: {
    RctiControl,
    RctiView
  }
};
</script>

<style>
</style>
